import { useAuth } from "../auth/AuthContext";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button, Card, Tabs, Tab } from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../../axiosConfig";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function FirmaCreate() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [judete, setJudete] = useState([]);
  const [activeTab, setActiveTab] = useState("generale");
  const [form, setForm] = useState({
    bxid: 0,
    bxdenumire: "",
    bxcodfiscal: "",
    bxadresa: "",
    bxregcom: "",
    bxtara: "",
    bxtel: "",
    bxfax: "",
    bxemail: "",
    platitor_tva: false,
    tva_la_incasare: false,
    tva_inc_afiseaza_bifa: false,
    bxoras: "",
    bxjudet_id: 0,
    bxsector_id: 0,
    bxcodpostal: "",
    bxfirst_date: "",
    bxlast_date: "",
    versiune_baza: "",
    bxcod_judet_san: "",
    bxsector: "",
    bxcap_social: "",
    zecimale_cantitate: 0,
    zecimale_pret: 0,
    judet_str: "",
    m_token: "",
    m_token_refresh: "",
    m_token_dataexp: "",
    cu_conturi_900: false,
    cu_serii: false,
    cont_taxa_vama_id: 0,
    cont_tva_vama_id: 0,
    cont_comision_vama_id: 0,
    preturi_catalog_cu_tva: false,
    cont_banca1: "",
    nume_banca1: "",
    cont_banca2: "",
    nume_banca2: "",
    atribut: "",
    contor_visible: false,
    santier_visible: false,
    medic_visible: false,
    distribuire_pe_centre: false,
    debugging: false,
    app_variant: "STANDARD",
    ver_parts: 2,
    ver_cda: 1,
  });

  useEffect(() => {
    api.get("/judet/?limit=100")
      .then((res) => {
        const items = Array.isArray(res.data) ? res.data : Array.isArray(res.data?.items) ? res.data.items : [];
        setJudete(items);
      })
      .catch((err) => console.error("Error loading judete:", err));
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setForm((f) => ({ ...f, [name]: checked }));
    } else if (type === "number") {
      setForm((f) => ({ ...f, [name]: value === "" ? "" : Number(value) }));
    } else if (name.endsWith("_id")) {
      setForm((f) => ({ ...f, [name]: value === "" ? 0 : Number(value) }));
    } else {
      setForm((f) => ({ ...f, [name]: value }));
    }
  };

  const handleDateChange = (fieldName, date) => {
    let str = "";
    if (date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      str = `${y}-${m}-${d}`;
    }
    setForm((f) => ({ ...f, [fieldName]: str }));
  };

  const handleAppVariantChange = (variant) => {
    if (variant === "LITE") {
      setForm((f) => ({
        ...f,
        app_variant: variant,
        santier_visible: false,
        contor_visible: false,
        ver_parts: 1,
        ver_cda: 1,
      }));
    } else {
      const isSimple =
        variant === "STANDARD" ||
        variant === "CONTOR" ||
        variant === "SERVICE_AUTO" || variant === "SANTIER";
      setForm((f) => ({
        ...f,
        app_variant: variant,
        ver_parts: 2,
        ver_cda: isSimple ? 1 : 2,
        santier_visible: variant === "SANTIER",
        contor_visible: variant === "CONTOR",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      const payload = { ...form };
      
      payload.bxid = Number(form.bxid) || 0;
      payload.platitor_tva = form.platitor_tva ? 1 : 0;
      payload.tva_la_incasare = form.tva_la_incasare ? 1 : 0;
      payload.tva_inc_afiseaza_bifa = form.tva_inc_afiseaza_bifa ? 1 : 0;
      payload.bxjudet_id = Number(form.bxjudet_id) || 0;
      payload.bxsector_id = Number(form.bxsector_id) || 0;
      payload.zecimale_cantitate = Number(form.zecimale_cantitate) || 0;
      payload.zecimale_pret = Number(form.zecimale_pret) || 0;
      payload.cu_conturi_900 = form.cu_conturi_900 ? 1 : 0;
      payload.cu_serii = form.cu_serii ? 1 : 0;
      payload.cont_taxa_vama_id = Number(form.cont_taxa_vama_id) || 0;
      payload.cont_tva_vama_id = Number(form.cont_tva_vama_id) || 0;
      payload.cont_comision_vama_id = Number(form.cont_comision_vama_id) || 0;
      payload.preturi_catalog_cu_tva = form.preturi_catalog_cu_tva ? 1 : 0;
      payload.santier_visible = form.santier_visible ? 1 : 0;
      payload.medic_visible = form.medic_visible ? 1 : 0;
      payload.distribuire_pe_centre = Boolean(form.distribuire_pe_centre);
      payload.debugging = Boolean(form.debugging);
      payload.contor_visible = form.contor_visible ? "1" : "0";
      payload.app_variant = form.app_variant || "STANDARD";
      payload.ver_parts = Number(form.ver_parts) || (form.app_variant === "LITE" ? 1 : 2);
      payload.ver_cda = Number(form.ver_cda) || (form.app_variant === "SIMAUS" ? 2 : 1);

      await api.post("/firma", payload);
      toast.success("Firma a fost creată cu succes!");
      navigate("/firma");
    } catch (err) {
      alert("Eroare la creare: " + (err.response?.data?.detail || err.message));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container className="mt-4 pb-5">
      <Card className="shadow-sm border-0">
        <Card.Header className="bg-success text-white py-3">
          <h4 className="mb-0">Creare Firmă Nouă</h4>
        </Card.Header>
        <Card.Body className="p-4">
          <Form onSubmit={handleSubmit}>
            <Tabs
              id="firma-create-tabs"
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              className="mb-4"
            >
              <Tab eventKey="generale" title="1. Date Generale">
                <Row className="g-3">
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Cod / ID Firmă</Form.Label>
                      <Form.Control
                        type="number"
                        name="bxid"
                        value={form.bxid ?? 0}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={7}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Denumire Firmă</Form.Label>
                      <Form.Control
                        type="text"
                        name="bxdenumire"
                        value={form.bxdenumire ?? ""}
                        onChange={handleChange}
                        required
                        placeholder="Numele oficial al societății"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Capital Social</Form.Label>
                      <Form.Control
                        type="text"
                        name="bxcap_social"
                        value={form.bxcap_social ?? ""}
                        onChange={handleChange}
                        placeholder="ex: 200 RON"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Cod Fiscal (CUI / CIF)</Form.Label>
                      <Form.Control
                        type="text"
                        name="bxcodfiscal"
                        value={form.bxcodfiscal ?? ""}
                        onChange={handleChange}
                        required
                        placeholder="ex: 12345678"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Atribut Fiscal</Form.Label>
                      <Form.Control
                        type="text"
                        name="atribut"
                        value={form.atribut ?? ""}
                        onChange={handleChange}
                        placeholder="ex: RO"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Registrul Comerțului</Form.Label>
                      <Form.Control
                        type="text"
                        name="bxregcom"
                        value={form.bxregcom ?? ""}
                        onChange={handleChange}
                        placeholder="ex: J40/1234/2020"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12} className="mt-4">
                    <Card className="bg-light border-0 p-3">
                      <Row>
                        <Col md={4}>
                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              id="platitor_tva"
                              name="platitor_tva"
                              label="Plătitor de TVA"
                              checked={!!form.platitor_tva}
                              onChange={handleChange}
                              className="fw-semibold text-dark"
                            />
                            <Form.Text className="text-muted">
                              Bifați dacă firma este înregistrată în scopuri de TVA.
                            </Form.Text>
                          </Form.Group>
                        </Col>

                        <Col md={4}>
                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              id="tva_la_incasare"
                              name="tva_la_incasare"
                              label="TVA la încasare"
                              checked={!!form.tva_la_incasare}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setForm((f) => ({
                                  ...f,
                                  tva_la_incasare: checked,
                                  tva_inc_afiseaza_bifa: checked ? f.tva_inc_afiseaza_bifa : false
                                }));
                              }}
                              className="fw-semibold text-dark"
                            />
                            <Form.Text className="text-muted">
                              Aplică regimul de TVA la încasare.
                            </Form.Text>
                            <Form.Check
                               type="checkbox"
                               id="tva_inc_afiseaza_bifa"
                               name="tva_inc_afiseaza_bifa"
                               label="Afișează bifa TVA la încasare în ieșiri"
                               checked={!!form.tva_inc_afiseaza_bifa}
                               onChange={handleChange}
                               disabled={!form.tva_la_incasare}
                               className="fw-semibold text-dark mt-2"
                             />
                             <Form.Text className="text-muted d-block">
                               Permite modificarea bifei pe facturile de ieșire (de ex. grup de firme).
                             </Form.Text>
                          </Form.Group>
                        </Col>

                        <Col md={4}>
                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              id="preturi_catalog_cu_tva"
                              name="preturi_catalog_cu_tva"
                              label="Prețuri catalog cu TVA inclus"
                              checked={!!form.preturi_catalog_cu_tva}
                              onChange={handleChange}
                              className="fw-semibold text-dark"
                            />
                            <Form.Text className="text-muted">
                              Prețurile din catalog conțin implicit taxa pe valoarea adăugată.
                            </Form.Text>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                </Row>
              </Tab>

              <Tab eventKey="adresa" title="2. Adresă și Contact">
                <Row className="g-3">
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Adresă Sediu Social</Form.Label>
                      <Form.Control
                        type="text"
                        name="bxadresa"
                        value={form.bxadresa ?? ""}
                        onChange={handleChange}
                        required
                        placeholder="Strada, Număr, Bloc, Apartament etc."
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Oraș / Localitate</Form.Label>
                      <Form.Control
                        type="text"
                        name="bxoras"
                        value={form.bxoras ?? ""}
                        onChange={handleChange}
                        placeholder="ex: Bucuresti, Timisoara"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Județ</Form.Label>
                      <Form.Select
                        name="bxjudet_id"
                        value={form.bxjudet_id ?? 0}
                        onChange={handleChange}
                      >
                        <option value={0}>-- Selectați Județul --</option>
                        {judete.map((j) => (
                          <option key={j.id} value={j.id}>
                            {j.denumire} ({j.cod})
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Sector ID</Form.Label>
                      <Form.Control
                        type="number"
                        name="bxsector_id"
                        value={form.bxsector_id ?? 0}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Cod Poștal</Form.Label>
                      <Form.Control
                        type="text"
                        name="bxcodpostal"
                        value={form.bxcodpostal ?? ""}
                        onChange={handleChange}
                        placeholder="ex: 010203"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Denumire Sector / Zonă</Form.Label>
                      <Form.Control
                        type="text"
                        name="bxsector"
                        value={form.bxsector ?? ""}
                        onChange={handleChange}
                        placeholder="ex: Sector 1"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Țară</Form.Label>
                      <Form.Control
                        type="text"
                        name="bxtara"
                        value={form.bxtara ?? ""}
                        onChange={handleChange}
                        placeholder="ex: Romania"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Cod Județ CAS (Sănătate)</Form.Label>
                      <Form.Control
                        type="text"
                        name="bxcod_judet_san"
                        value={form.bxcod_judet_san ?? ""}
                        onChange={handleChange}
                        placeholder="ex: B, CJ, TM"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Telefon</Form.Label>
                      <Form.Control
                        type="text"
                        name="bxtel"
                        value={form.bxtel ?? ""}
                        onChange={handleChange}
                        placeholder="ex: 0722000000"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Fax</Form.Label>
                      <Form.Control
                        type="text"
                        name="bxfax"
                        value={form.bxfax ?? ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Email</Form.Label>
                      <Form.Control
                        type="email"
                        name="bxemail"
                        value={form.bxemail ?? ""}
                        onChange={handleChange}
                        placeholder="ex: contact@firma.ro"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Județ (Denumire Textuală)</Form.Label>
                      <Form.Control
                        type="text"
                        name="judet_str"
                        value={form.judet_str ?? ""}
                        onChange={handleChange}
                        placeholder="ex: Bucuresti"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Tab>

              <Tab eventKey="financiare" title="3. Date Financiare">
                <Row className="g-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Cont IBAN Bancă 1</Form.Label>
                      <Form.Control
                        type="text"
                        name="cont_banca1"
                        value={form.cont_banca1 ?? ""}
                        onChange={handleChange}
                        placeholder="RO00AAAA0000000000000000"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Denumire Bancă 1</Form.Label>
                      <Form.Control
                        type="text"
                        name="nume_banca1"
                        value={form.nume_banca1 ?? ""}
                        onChange={handleChange}
                        placeholder="ex: BCR, BRD"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Cont IBAN Bancă 2</Form.Label>
                      <Form.Control
                        type="text"
                        name="cont_banca2"
                        value={form.cont_banca2 ?? ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Denumire Bancă 2</Form.Label>
                      <Form.Control
                        type="text"
                        name="nume_banca2"
                        value={form.nume_banca2 ?? ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Zecimale Cantitate</Form.Label>
                      <Form.Control
                        type="number"
                        name="zecimale_cantitate"
                        value={form.zecimale_cantitate ?? 0}
                        onChange={handleChange}
                        min={0}
                        max={6}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Zecimale Preț</Form.Label>
                      <Form.Control
                        type="number"
                        name="zecimale_pret"
                        value={form.zecimale_pret ?? 0}
                        onChange={handleChange}
                        min={0}
                        max={6}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6} className="d-flex align-items-center">
                    <Form.Group className="mb-0 mt-3">
                      <Form.Check
                        type="checkbox"
                        id="cu_conturi_900"
                        name="cu_conturi_900"
                        label="Utilizează conturi din clasa 9 (Contabilitate de gestiune)"
                        checked={!!form.cu_conturi_900}
                        onChange={handleChange}
                        className="fw-semibold"
                      />
                      
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">ID Cont Taxă Vamă</Form.Label>
                      <Form.Control
                        type="number"
                        name="cont_taxa_vama_id"
                        value={form.cont_taxa_vama_id ?? 0}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">ID Cont TVA Vamă</Form.Label>
                      <Form.Control
                        type="number"
                        name="cont_tva_vama_id"
                        value={form.cont_tva_vama_id ?? 0}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">ID Cont Comision Vamă</Form.Label>
                      <Form.Control
                        type="number"
                        name="cont_comision_vama_id"
                        value={form.cont_comision_vama_id ?? 0}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Tab>

              <Tab eventKey="anaf" title="4. e-Factura ANAF">
                <Row className="g-3">
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Token ANAF (M Token)</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="m_token"
                        value={form.m_token ?? ""}
                        onChange={handleChange}
                        placeholder="Token-ul pentru autorizare in e-Factura"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Refresh Token ANAF</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        name="m_token_refresh"
                        value={form.m_token_refresh ?? ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Dată Expirare Token ANAF</Form.Label>
                      <DatePicker
                        selected={form.m_token_dataexp ? new Date(form.m_token_dataexp) : null}
                        onChange={(date) => handleDateChange("m_token_dataexp", date)}
                        dateFormat="dd.MM.yyyy"
                        className="form-control"
                        placeholderText="Selectați data"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Tab>

              <Tab eventKey="admin" title="5. Administrare și Module">
                <Row className="g-3">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Prima zi (început exercițiu)</Form.Label>
                      <DatePicker
                        selected={form.bxfirst_date ? new Date(form.bxfirst_date) : null}
                        onChange={(date) => handleDateChange("bxfirst_date", date)}
                        filterDate={(date) => date.getDate() === 1}
                        dateFormat="dd.MM.yyyy"
                        className="form-control"
                        placeholderText="Selectați data"
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Ultima zi (sfârșit exercițiu)</Form.Label>
                      <DatePicker
                        selected={form.bxlast_date ? new Date(form.bxlast_date) : null}
                        onChange={(date) => handleDateChange("bxlast_date", date)}
                        dateFormat="dd.MM.yyyy"
                        className="form-control"
                        placeholderText="Selectați data"
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12} className="mt-4">
                    <Card className="bg-light border-0 p-3">
                      <h6 className="fw-bold mb-3">Variantă Aplicație și Module Active</h6>
                      <Row className="g-3">
                        <Col md={12} className="mb-3">
                          <Form.Group>
                            <Form.Label className="fw-semibold d-block">
                              Variantă Aplicație
                            </Form.Label>
                            <div className="d-flex flex-wrap gap-4 align-items-center py-2 border rounded px-3 bg-white">
                              {[
                                "LITE",
                                "STANDARD",
                                "SANTIER",
                                "SERVICE_AUTO",
                                "CONTOR",
                              ].map((variant) => (
                                <Form.Check
                                  inline
                                  type="radio"
                                  id={`create-app-variant-${variant}`}
                                  key={variant}
                                  label={variant}
                                  name="app_variant"
                                  checked={form.app_variant === variant}
                                  onChange={() => handleAppVariantChange(variant)}
                                  className="fw-semibold mb-0"
                                />
                              ))}
                            </div>
                            <Form.Text className="text-muted">
                              Alegeți varianta potrivită activității firmei. După creare, varianta poate fi schimbată numai de superadmin.
                            </Form.Text>
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              id="distribuire_pe_centre"
                              name="distribuire_pe_centre"
                              label="Distribuire pe centre de cost (validare la scrierea notei contabile)"
                              checked={!!form.distribuire_pe_centre}
                              onChange={handleChange}
                              className="fw-semibold"
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6} style={{ display: "none" }}>
                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              id="medic_visible"
                              name="medic_visible" disabled={!user?.is_superuser || user?.user_name !== "superadmin"}
                              label="Activează modul Cabinet Medical"
                              checked={!!form.medic_visible}
                              onChange={handleChange}
                              className="fw-semibold"
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              id="debugging"
                              name="debugging"
                              label="Mod Depanare (afișează coloana Debug)"
                              checked={!!form.debugging}
                              onChange={handleChange}
                              className="fw-semibold text-danger"
                            />
                          </Form.Group>
                        </Col>

                        <Col md={12} className="mt-3">
                          <Row className="align-items-center">
                            <Col xs="auto">
                              <Form.Label className="fw-semibold mb-0">Versiune Bază Date:</Form.Label>
                            </Col>
                            <Col xs="auto">
                              <Form.Control
                                type="text"
                                name="versiune_baza" readOnly
                                value={form.versiune_baza ?? ""}
                                onChange={handleChange}
                                size="sm"
                                style={{ width: "90px" }}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                </Row>
              </Tab>
            </Tabs>

            <hr />

            <div className="d-flex justify-content-between align-items-center mt-4">
              <Button variant="secondary" onClick={() => navigate("/firma")}>
                Renunță
              </Button>
              <Button variant="success" type="submit" size="lg" disabled={submitting}>
                {submitting ? "Se creează..." : "Creează firma"}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}
